import { BaseEvent, eventRegistry } from "@Context/common/general/event-context";
import * as t from "io-ts";

// Define the subscription event type using io-ts
export const SubscriptionEventType = t.intersection([
  t.type({
    type: t.union([t.literal("subscription_updated"), t.literal("subscription_cancelled"), t.literal("subscription_resumed")]),
    subscriptionId: t.string,
    timestamp: t.number,
  }),
  t.partial({
    seatChange: t.number,
  }),
]);

// Type alias for TypeScript
export type SubscriptionEvent = t.TypeOf<typeof SubscriptionEventType> & BaseEvent;

// Register subscription events
const subscriptionEmitter = eventRegistry.registerEventType<typeof SubscriptionEventType, SubscriptionEvent>("subscription", SubscriptionEventType);

// Helper functions to emit subscription events
export const subscriptionEvents = {
  emitSubscriptionUpdated: (subscriptionId: string, payload?: { seatChange?: number }) => {
    subscriptionEmitter.emit({
      type: "subscription_updated",
      subscriptionId,
      timestamp: Date.now(),
      ...payload,
    });
  },

  // Helper to subscribe to all subscription events
  onSubscriptionChange: (callback: (event: SubscriptionEvent) => void) => {
    return subscriptionEmitter.on(callback);
  },
};
